"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@apollo/client/core");
var money_1 = require("../money");
var price_1 = require("../price");
var offers_1 = require("../offers");
var dealCarPrice = {
    DEAL_CAR_PRICE: core_1.gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n    fragment DealCarPrice on DealCarPrice {\n      originalPrice {\n        ...Price\n      }\n      totalDiscount {\n        ...Money\n      }\n      finalPrice {\n        ...Price\n      }\n      offers {\n        ...Offers\n      }\n    }\n  "], ["\n    ", "\n    ", "\n    ", "\n    fragment DealCarPrice on DealCarPrice {\n      originalPrice {\n        ...Price\n      }\n      totalDiscount {\n        ...Money\n      }\n      finalPrice {\n        ...Price\n      }\n      offers {\n        ...Offers\n      }\n    }\n  "])), price_1.default.PRICE, money_1.default.MONEY, offers_1.default.OFFERS),
};
exports.default = dealCarPrice;
var templateObject_1;
